module.exports = __webpack_public_path__ + "static/img/ross_noble_ani_extended_size_00082-fs8.effdaea.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/animation/ross_noble_ani_extended_size_00082-fs8.png
// module id = 235
// module chunks = 0